/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Contact_Extend_Wrapup_SecondsInputs */

const en_forms_users_settings_contact_extend_wrapup_seconds = /** @type {(inputs: Forms_Users_Settings_Contact_Extend_Wrapup_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seconds`)
};

const de_forms_users_settings_contact_extend_wrapup_seconds = /** @type {(inputs: Forms_Users_Settings_Contact_Extend_Wrapup_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlängerung der Nachbearbeitungszeit in Sekunden`)
};

/**
* | output |
* | --- |
* | "Seconds" |
*
* @param {Forms_Users_Settings_Contact_Extend_Wrapup_SecondsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_contact_extend_wrapup_seconds = /** @type {((inputs?: Forms_Users_Settings_Contact_Extend_Wrapup_SecondsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Contact_Extend_Wrapup_SecondsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_contact_extend_wrapup_seconds(inputs)
	return de_forms_users_settings_contact_extend_wrapup_seconds(inputs)
});